// extracted by mini-css-extract-plugin
module.exports = {"main_div":"navtoggle_main_div__2WHe-","main_page":"navtoggle_main_page__11W5P"};